import React from 'react'
import SidebarHeader from '../Form/BackArrow/SidebarHeader'
import { MultiSelect } from "primereact/multiselect";
import { formatINR, formatINRShort } from '../../utils/formatINR';
const ViewAdvanceAmountCard = ({
    selectedDealData,
    handleAdvancePaymentBack,
    selectedPaymentType,
    handleFilterPaymentType,
    bookingPaymentType,
    totalCostOfProperty,
    totalReceivedAmount,
    pendingAmount,
    excessAmount,
    totalReceivedAmountOfPaymentType3,
    dealStageSelected,
    filteredTransactions,
    
}) => {
  return (
    <>
    <SidebarHeader onClick={handleAdvancePaymentBack} title={" Advance Payment"}/>
          
          <div className="mb-5">
            <label className="font-semibold">Filter by Payment Type:</label>

            <MultiSelect
              value={selectedPaymentType}
              onChange={handleFilterPaymentType}
              options={Object.entries(bookingPaymentType).map(
                ([key, value]) => ({
                  label: value,
                  value: key,
                })
              )}
              optionLabel="label"
              filter
              placeholder="Select Payment Type"
              maxSelectedLabels={3}
            />
          </div>
          <div className="w-full p-5 mt-5 rounded-lg shadow-md">
            <div className="flex justify-between gap-5 mb-4">
              <div className="text-lg font-bold ">Total Amount :</div>
              <div title={formatINR(totalCostOfProperty)} className="w-52 bg-slate-100 rounded-md pl-2 text-black ">
                {formatINRShort(totalCostOfProperty)}
              </div>
            </div>

            <div className="flex justify-between mb-4">
              <div className="text-lg font-bold">Registration :</div>
              <div title={formatINR(selectedDealData?.registrationPayments
                  ?.totalRegistrationAmount)} className="w-52 bg-slate-100 rounded-md pl-2 text-black">
                {formatINRShort(selectedDealData?.registrationPayments
                  ?.totalRegistrationAmount) || ""}
              </div>
            </div>

            <div className="flex justify-between mb-4">
              <div className="text-lg font-bold">Received Amt :</div>
              <div title={formatINR(totalReceivedAmount)} className="w-52 bg-slate-100 rounded-md pl-2 text-black">
                {formatINRShort(totalReceivedAmount)}
              </div>
            </div>

            <div className="flex justify-between mb-4">
              <div className="text-lg font-bold">Pending Amt :</div>
              <div  title={formatINR(pendingAmount)} className="w-52 bg-slate-100 rounded-md pl-2 text-black">
                {formatINRShort(pendingAmount)}
              </div>
            </div>

            <div className="flex justify-between mb-4">
              <div className="text-lg font-bold">Excess Amt :</div>
              <div title={formatINR(excessAmount)} className="w-52 bg-slate-100 rounded-md pl-2 text-black">
                {formatINRShort(excessAmount)}
              </div>
            </div>
            {dealStageSelected === "Deal Lost After Booking" && (
              <div className="flex justify-between mb-4">
                <div className="text-lg font-bold text-red-500">
                  Refunded Amt :
                </div>
                <div title={formatINR(totalReceivedAmountOfPaymentType3)} className="w-52 bg-slate-100 rounded-md pl-2 text-black">
                  {formatINRShort(totalReceivedAmountOfPaymentType3)}
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-center mt-10">
            <hr className="border-t-2 border-solid border-slate-300 border-1 mb-4 w-3/6" />
          </div>

          <div className="mt-1">
            <div className="text-center text-lg font-semibold">
              Transactions
            </div>
            {filteredTransactions.length > 0 ? (
              filteredTransactions.reverse().map((advancePayment, index) => (
                <div
                  key={index}
                  className="w-full p-5 mt-5 rounded-lg shadow-md bg-white border border-gray-300"
                >
                  <div className="mb-5">
                    <div
                      className={`text-xl ${
                        advancePayment.paymentDefinition === 1
                          ? "text-customGreen"
                          : "text-red-500"
                      } font-bold mb-3`}
                    >
                      {advancePayment?.title}
                    </div>

                    <div className="flex mb-2">
                      <div className="font-semibold">Amount Received:</div>
                      <div title={formatINR(advancePayment?.amountReceived)} className="text-gray-800">
                        {formatINRShort(advancePayment?.amountReceived)}
                      </div>
                    </div>
                    <div className="flex mb-2">
                      <div className="font-semibold">Payment Type:</div>
                      <div className="text-gray-800">
                        {
                          bookingPaymentType[
                            advancePayment?.advanceAmountPaymentType
                          ]
                        }
                      </div>
                    </div>

                    <div className="flex mb-2">
                      <div className="font-semibold">Comment:</div>
                      <div className="text-gray-800">
                        {advancePayment?.paymentComment}
                      </div>
                    </div>

                    <div className="flex mb-2">
                      <div className="font-semibold">Payment Time:</div>
                      <div className="text-gray-800">
                        {new Date(
                          advancePayment?.createdTimeStamp._seconds * 1000
                        ).toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-red-500 text-center">
                <h2>No Transaction Available</h2>
              </div>
            )}
          </div>
    </>
  )
}

export default ViewAdvanceAmountCard